export default __webpack_public_path__ + "static/media/Icon-1024x1024-Full-White-Version.5be51e24.png";